module.exports = __webpack_public_path__ + "img/17.d69319d9.png";